import tingle from "tingle.js"
import { q, qq } from "../../helper/q"
import hyperform from "hyperform"
import { floatInputInit } from "../../globals/floatinput"
import maskInput from "vanilla-text-mask"

export const singupInit = () => {
  const buttons = qq(".schoolListBrewing li button")
  const modal = new tingle.modal({
    footer: false,
    stickyFooter: false,
    closeMethods: ["overlay", "escape"],
    closeLabel: "Close",
    onOpen: () => {
      q(".enrollmentPopupClose").addEventListener("click", () => {
        modal.close()
      })
    },
    beforeClose: function() {
      q(".enrollmentPopupClose").removeEventListener("click", () => {
        modal.close()
      })
      return true
    }
  })

  buttons.map(button => {
    button.addEventListener("click", () => {
      fetch(`/ajax/boiler-online.php?boilerId=${button.dataset.id}`, {})
        .then(content => content.text())
        .then(data => {
          modal.setContent(data)
          modal.open()
          formInit(modal.getContent())
        })
    })
  })
}

const formInit = form => {
  floatInputInit()
  hyperform.addValidator(form.querySelector("input[type='tel']"), element => {
    const re = /^(\+7|7|8)?[\s/\\-]?\(?[0-9]{3}\)?[\s/\\-]?[0-9]{3}[\s/\\-]?[0-9]{2}[\s/\\-]?[0-9]{2}$/gm
    const valid = re.test(element.value)
    element.setCustomValidity(valid ? "" : element.value ? element.dataset.typeMismatch : element.dataset.valueMissing)
    return valid
  })
  maskInput({
    inputElement: form.querySelector('input[type="tel"]'),
    mask: ["+", /[1-9]/, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
    showMask: false,
    keepCharPositions: false
  })
  hyperform.setRenderer("attachWarning", function(warning, element) {
    element.parentNode.classList.add("floatInputError")
    element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
  })
  hyperform(form)

  form.addEventListener("submit", e => {
    e.preventDefault()
    const data = new FormData(q("form", form))
    fetch(q("form", form).action, {
      method: "POST",
      body: data,
      credentials: "include"
    })
  })
}
